import React, { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { motion, AnimatePresence } from "framer-motion";
import { FaBell, FaGlobe, FaUserShield } from "react-icons/fa";
import logoForHeader from "../../../Assests/images.jpg";
import { navigationItems } from "../../../lib/definitions";
import HeaderSearch from "./headerSearch";
import { GetNotificationsUnreadData } from "../../../lib/data";
import { LogoutForm, updateReadAllNotificationForm } from "../../../lib/actions";
import { useDispatch, useSelector } from "react-redux";
import { notificationsActions } from "../../../lib/stores/notifications";
import { useTranslation } from "react-i18next";
import userPhoto from "../../../Assests/Frame 129.svg"

export const Header = () => {

  // const notificationsItems = useSelector((state) => state.notifications.items);
  const notificationsQuantity = useSelector((state) => state.notifications.totalQuantity);
  const [showNotifications, setShowNotifications] = useState(false);
  const [notificationsData, setNotificatiosData] = useState([]);
  const [showLanguages, setShowLanguages] = useState(false);
  const [showProfile, setShowProfile] = useState(false);
  const [currentPage, setcurrentPage] = useState(1);
  const [numberOfNoti, setNumberOfNoti] = useState(notificationsQuantity ? 1 : 0);
  const [last_page, setlast_page] = useState(1);
  const [isLoading, setIsLoading] = useState(true);  
  const nav = useNavigate();
  const dispatch = useDispatch();
  const { t, i18n } = useTranslation();
  const currentLang = i18n.language;
  const deviceToken = localStorage.getItem("fcToken");  

  const notifRef = useRef(null);
  const profileRef = useRef(null);
  const langRef = useRef(null);

  const userName = localStorage.getItem("username");
  const roleName = localStorage.getItem("role_name");


  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        notifRef.current &&
        !notifRef.current.contains(event.target) &&
        profileRef.current &&
        !profileRef.current.contains(event.target) &&
        langRef.current &&
        !langRef.current.contains(event.target)
      ) {
        setShowNotifications(false);
        setShowProfile(false);
        setShowLanguages(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);
  
  const handleLogout = async () => {
    const formData = new FormData();
    formData.append("device_token", deviceToken);
    await LogoutForm(formData);
    nav("/login");
    localStorage.removeItem("fcToken");
    localStorage.removeItem("permissions");
    localStorage.removeItem("stream_token");
    localStorage.removeItem("stream_user_name");
    localStorage.removeItem("token");
    localStorage.removeItem("State");
    localStorage.removeItem("role_name");
    localStorage.removeItem("username");
    localStorage.removeItem("timeLeft");
  };

  const handleNavigate = () => {
    nav("/notifications");
    setShowNotifications(false);
  };
  
  const handleNavigateNotifications = (e) => {
    
    if (e.startsWith("orders")) {
      nav(`/orders?id=${e.split("/")[1]}`);
    }
    else if (e.startsWith("ad")){
      nav(`/ads?id=${e.split("/")[1]}`);
    }
    else if (e.startsWith("users")){
      nav(`/users/details/${e.split("/")[1]}`);
    }
    setShowNotifications(false);
  };
  
  useEffect(() => {
    setNumberOfNoti(notificationsQuantity ? 1 : 0);
    handleApi();
  }, [showNotifications, notificationsQuantity])

  const handleApi = async () => {
    setIsLoading(true); 
    const notificationData = await GetNotificationsUnreadData(currentPage);
    setNotificatiosData([]);
    setcurrentPage(notificationData.pagination.current_page);
    setNumberOfNoti(notificationData.pagination.total);
    setlast_page(notificationData.pagination.last_page);
    notificationData.data.map((e) => setNotificatiosData((prev) => [...prev, e]));
    setIsLoading(false);  
  };

  const handleReadNotification = async () => {
    setIsLoading(true);
    const result = await updateReadAllNotificationForm();
    setIsLoading(false);
    if (result) {
      setNotificatiosData([]);
      dispatch(notificationsActions.clearFavorite()); 
      setNumberOfNoti(0);
    };
  }

  const handlePageChange = (page) => {
      setcurrentPage(page);
  };

  const toggleLanguage = () => {
    const newLang = i18n.language === 'en' ? 'ar' : 'en';
    i18n.changeLanguage(newLang);
    window.location.reload(); 
  };

  return (
    <div className="flex items-center justify-between bg-primary sm:px-4 px-1 py-4 ">
 
      <div className="flex items-center gap-2 bg-furthly text-gray-400 px-4 py-2 rounded-lg sm:w-72 w-44">
        <HeaderSearch navigationItems={navigationItems} />
      </div>

      <div className="flex items-center sm:gap-6 relative sm:p-2">
        
        <div className="relative" ref={langRef}>
          <button
            onClick={() => {
              setShowLanguages(!showLanguages);
              setShowNotifications(false);
              setShowProfile(false);
              toggleLanguage()
            }}
            className="p-2 rounded-full hover:bg-[#3a3b45] text-gray-300"
          >
            <div className="flex flex-col justify-start items-center">
              <FaGlobe size={18} />
              {currentLang === "en" ? <p className="absolute top-[26px] text-xs">AR</p> : <p className="absolute top-[26px] text-xs">EN</p>}
            </div>
          </button>
        </div>
       
        <div className="relative" ref={notifRef}>
          <button
            onClick={() => {
              setShowNotifications(!showNotifications);
              setNotificatiosData([]);
              setShowLanguages(false);
              setShowProfile(false);
            }}
            className="relative p-2 rounded-full hover:bg-[#3a3b45] text-gray-300"
          >
            <FaBell size={18}/>
            {numberOfNoti != 0 &&
              <span className="absolute top-1 right-1 bg-red-500 w-2 h-2 rounded-full"></span>
            }
          </button>

          <AnimatePresence>
            {showNotifications && (
              <motion.div
                initial={{ opacity: 0, y: -10 }}
                animate={{ opacity: 1, y: 0 }}
                exit={{ opacity: 0, y: -10 }}
                className={`absolute ${currentLang === "en" ? "right-0" : "left-0"} mt-2 w-80 z-10 bg-[#2d2f36] text-gray-200 rounded-lg shadow-lg border border-[#3a3b45]`}
              >  
                <div className="flex items-center justify-between px-4 py-2 border-b border-[#3a3b45]">
                  <h3 className="font-semibold">{currentLang === "en" ? "Notifications " : "الاشعارات"}</h3>
                  <span className="text-xs bg-red-600 px-2 py-1 rounded-full">{numberOfNoti}{currentLang === "en" ? "new " : "  جديد"}</span>
                </div>
                {(notificationsData.length != 0 && !isLoading) ? <>
                  <div className="max-h-80 overflow-y-auto sidebar-scroll">
                    {notificationsData.map((e) => (
                      <div className="px-4 py-3 border-b border-[#3a3b45] cursor-pointer" key={e.id} onClick={() => handleNavigateNotifications(e.link)}>
                        <p className="font-medium text-center mb-1">{e.title}</p>
                        <p className="text-sm text-gray-400 text-left">{e.description}</p>
                        <p className="text-xs text-gray-300 mt-2 text-right">{e.created_at}</p>
                      </div>
                    ))}
                  </div>
                  <div className="flex justify-between items-center gap-3 px-4 py-2 border-t border-[#3a3b45]">
                    <button className="px-6 py-1 bg-secondary rounded-lg text-[15px] cursor-pointer" onClick={handleNavigate}>
                      {currentLang === "en" ? "View All Notifications" : "اظهار كل الاشعارات"}
                    </button>
                    <button onClick={handleReadNotification} className="px-5 py-1 bg-[#8b95a7] cursor-pointer rounded-lg text-[#0b1220] text-[15px]">
                      {currentLang === "en" ? "Read All" : " قراءة الكل"}
                    </button>
                  </div>
                </>
                : isLoading ? 
                  <div className="flex justify-center items-center h-32">
                    <svg
                      className="animate-spin h-5 w-5" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                      <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" ></circle>
                      <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8v8H4z"></path>
                    </svg>
                  </div>
                : 
                  <div className="text-center py-5">
                    <h2 className="text-[14px]">{currentLang === "en" ? "There Is No Notifications To Read " : "  لا يوجد اشعارات غير مقروءة"}</h2>
                  </div>
                }
              </motion.div>
            )}
          </AnimatePresence>
        </div>

        <div className="relative" ref={profileRef}>
          <button
            onClick={() => {
              setShowProfile(!showProfile);
              setShowNotifications(false);
              setShowLanguages(false);
            }}
            className=" rounded-full border-[3px] border-secondary  hover:bg-[#3a3b45] text-gray-300"
          >
           <img src={userPhoto} className="w-7 h-7  "/>
          </button>

          <AnimatePresence>
            {showProfile && (
              <motion.div
                initial={{ opacity: 0, y: -10 }}
                animate={{ opacity: 1, y: 0 }}
                exit={{ opacity: 0, y: -10 }}
                className={`absolute ${currentLang === "en" ? "right-0" : "left-0"} mt-2 w-40 z-10 bg-[#2d2f36] text-gray-200 rounded-lg shadow-lg border border-[#3a3b45] overflow-hidden`}
              >
                <ul className="divide-y divide-[#3a3b45]">
                  <li className="px-4 py-2 text-center hover:bg-[#3a3b45] text-white cursor-pointer">{userName}</li>
                  <li className="px-4 py-2 flex justify-evenly items-center hover:bg-[#3a3b45] text-white cursor-pointer"> {roleName} <FaUserShield/> </li>
                  <button className="px-4 py-2 w-full bg-danger hover:bg-red-700 cursor-pointer" onClick={()=>handleLogout()}>{currentLang === "en" ? "Logout " : " تسجيل الخروج"}</button>
                </ul>
              </motion.div>
            )}
          </AnimatePresence>
        </div>

      </div>
    </div>
  );
}
